<template>
  <div class="openai">
    <div class="my-header">
      <div class="title">
        <span>智能助手</span>        
        <el-select v-model="modelType" placeholder="选择大模型平台" size="mini" @change="modelTypeSelectChange">
          <el-option-group v-for="group in options" :key="group.label" :label="group.label" v-show="group.isEnable">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>          
      </div> 
      <el-button type="primary" plain style="margin-right:5px;" size="mini" @click="newChat">新对话</el-button> 
    </div>
    <div :style="contentStyle" ref='scrollContainer' @scroll="onScroll">
      <div v-for="(item,index,) in history" :key="index" style="margin-left:10px;padding:8px 15px 8px 10px;display:flex;flex-flow:row;justify-content:flex-start;align-items:flex-start">
        <div style="width:24px">
          <svg-icon icon-class="Assistant-1" className="icon-assistant" v-show="item.role=='assistant'"/>
          <el-image v-show="item.role=='user'" :src="avatar?avatar:require('@/assets/images/empty-avatar.png')"/>
        </div>
        <vue-typed-js style='margin-left:10px' @onBegin="handleOnBegin" @onComplete="handleOnComplete" :strings="[compileMarkdown(item.content)]" v-if="item.role!='system'">
          <span class="typing"></span>
        </vue-typed-js>
      </div>
    </div>
    <div class="question">
      <el-input type="textarea" maxlength="100" show-word-limit v-model="message" :rows="5" clearable placeholder="请填写您的问题...." style="width:calc(100% - 2px);margin-top:3px" @keyup.enter.native="submit"></el-input>
      <svg-icon icon-class="Attachment" className="icon-attachment" @click="uploadAttachment" v-if="['moonshot-v1-8k','moonshot-v1-32k','moonshot-v1-128k','qwen-long'].includes(modelType)"/>      
      <svg-icon icon-class="Send" className="icon-send" @click="submit"/> 
    </div>    
    <div v-if="file" class="attachment">
      <div class="file-title">
        <el-image class="image" v-if="['.pdf','.PDF'].includes(file.type)" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(file.url)"></el-image>
        <el-image class="image" v-else-if="['.xls','.xlsx','.XLS','.XLSX'].includes(file.type)" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(file.url)"></el-image>
        <el-image class="image" v-else-if="['.doc','.docx','.DOC','.DOCX'].includes(file.type)" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(file.url)"></el-image>
        <el-image class="image" v-else-if="['.ppt','.pptx','.PPT','.PPTX'].includes(file.type)" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(file.url)"></el-image>
        <el-image class="image" v-else-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(file.type)" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(file.url)"></el-image>
        <el-image class="image" v-else-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(file.type)" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewImage(file.url)"></el-image>
        <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(file.url)"></el-image>
        <span>{{ file.file_originalname }}</span>       
      </div>
      <svg-icon className='Delete-icon' icon-class="Delete" @click="attachmentDelete(file.file_object.id,file.url)"/> 
    </div>
  </div>
</template>
<script>
import UploadFile from './Upload/index'
import Store from '@/store'
import http from '@/http'

export default {
  components:{
    'vue-typed-js':()=>import('./VueTypedJs')
  },
  data() {
    return {
      modelType:'moonshot-v1-8k',
      avatar:Store.state.avatar,
      message:null,
      timer:null,
      contentStyle:{
        width: 'calc(100% - 2px)',
        height:'calc(100vh - 160px)',
        border: '1px solid #DCDFE6',
        'border-radius': '4px',
        overflow: 'auto',
        'margin-top': '2px',
        background: '#ebebeb'
      },
      file:null,
      history:[{
        role:'assistant',
        content:`您好, 有什么问题我可以帮你解答吗？`
      }], // 维护对话历史的消息数组
      MAX_HISTORY:20, // 设置最大消息数限制
      MAX_FILE_HISTORY:16, // 设置最大消息数限制
      options: [
        {
          label: '月之暗面',
          modelType:'kimi',
          isEnable:true,
          options: [{
            value: 'moonshot-v1-8k',
            label: 'moonshot-v1-8k',
            remark:'上下文长度(8k Token), 输入和输出总计(12元/每百万Token)'
          }, {
            value: 'moonshot-v1-32k',
            label: 'moonshot-v1-32k',
            remark:'上下文长度(32k Token), 输入和输出总计(24元/每百万Token)'
          }, {
            value: 'moonshot-v1-128k',
            label: 'moonshot-v1-128k',
            remark:'上下文长度(128k Token), 输入和输出总计(60元/每百万Token)'
          }]
        }, 
        {
          label: '通义千问',
          modelType:'qwen',
          isEnable:true,
          options: [ {
            value: 'qwen-long',
            label: '通义千问-Long',
            remark:'支持总结和分析长达千万字的文档, 且成本极低, 上下文长度(10000k Token), 输入(0.0005元/每千Token), 输出(0.002元/每千Token)'
          }, {
            value: 'qwen-turbo',
            label: '通义千问-Turbo',
            remark:'通义千问系列速度最快、成本很低的模型, 适合简单任务, 上下文长度(8k Token), 输入(0.002元/每千Token), 输出(0.006元/每千Token)'
          },  {
            value: 'qwen-plus',
            label: '通义千问-Plus',
            remark:'能力均衡, 推理效果和速度介于通义千问-Max和通义千问-Turbo之间, 适合中等复杂任务, 上下文长度(131k Token), 输入(0.004元/每千Token), 输出(0.012元/每千Token)'
          },{
            value: 'qwen-max',
            label: '通义千问-Max',
            remark:'通义千问系列效果最好的模型, 适合复杂、多步骤的任务, 上下文长度(8k或30k Token), 输入(0.04元/每千Token), 输出(0.12元/每千Token)'
          },{
            value: 'qwen-math-plus',
            label: '通义千问-Math',
            remark:'通义千问数学模型是专门用于数学解题的语言模型'
          }]
        }],
    };
  },
  methods: {
    modelTypeSelectChange(e){
      this.newChat()     
    },
    async submit(){
      if(this.message&&['moonshot-v1-8k','moonshot-v1-32k','moonshot-v1-128k'].includes(this.modelType)){
        // 将新消息添加到历史记录中
        this.history.push({ role: "user", content: this.message });
        // 如果消息数超过最大限制, 截断数组以保留最新的对话
        if(this.file){
          if(this.history.length > this.MAX_FILE_HISTORY){
            await http.delete(`/openai/kimi/file/${this.file.file_object.id}`);
            await http.delete("/oss/upload/file",{data:{url:this.file.url}});
            this.file=null
            this.contentStyle.height='calc(100vh - 160px)'
            this.history=[{
              role:'assistant',
              content:`您好, 有什么问题我可以帮你解答吗？`
            }]
          }else{
            const res = await http.post('/openai/kimi/chat',{message:this.history,modelType:this.modelType});
            // 获取Kimi的回复并添加到历史记录中
            this.history.push(res.data);            
          }
        }else{
          if(this.history.length > this.MAX_HISTORY) {
            this.history = this.history.slice(-this.MAX_HISTORY);
          }
          const res = await http.post('/openai/kimi/chat',{message:this.history,modelType:this.modelType});
          // 获取Kimi的回复并添加到历史记录中
          this.history.push(res.data);
        }
      }else if(this.message&&['qwen-max','qwen-turbo','qwen-plus','qwen-math-plus'].includes(this.modelType)){
        // 将新消息添加到历史记录中
        this.history.push({ role: "user", content: this.message });
        if(this.history.length > this.MAX_HISTORY) {
          this.history = this.history.slice(-this.MAX_HISTORY);
        }
        const res = await http.post('/openai/qwen/chat',{message:this.history,modelType:this.modelType});
        // 获取Kimi的回复并添加到历史记录中
        this.history.push(res.data);
      }else if(this.message&&['qwen-long'].includes(this.modelType)){
        // 将新消息添加到历史记录中
        this.history.push({ role: "user", content: this.message });
        // 如果消息数超过最大限制, 截断数组以保留最新的对话
        if(this.history.length > this.MAX_FILE_HISTORY){
          await http.delete(`/openai/qwen/file/${this.file.file_object.id}`);
          await http.delete("/oss/upload/file",{data:{url:this.file.url}});
          this.file=null
          this.contentStyle.height='calc(100vh - 160px)'
          this.history=[{
            role:'assistant',
            content:`您好, 有什么问题我可以帮你解答吗？`
          }]
        }else{
          const res = await http.post('/openai/qwen/chat',{message:this.history,modelType:this.modelType});
          // 获取Kimi的回复并添加到历史记录中
          this.history.push(res.data)
        }
      }
      this.message=null
    },
    updateAttachment(data){
      if(data.file_content||data.file_object){
        this.contentStyle.height='calc(100vh - 260px)'
        this.file=data 
        if(['moonshot-v1-8k','moonshot-v1-32k','moonshot-v1-128k'].includes(this.modelType)){
          this.history=[
            {
                role: "system",
                content: data.file_content,
            },
            {
                role: "assistant", 
                content: `你上传了名称为<${data.file_originalname}>的文件,\n请注意：由于流量限制, 我将最多回答${(this.MAX_FILE_HISTORY-2)/2}个有关该文件的问题, 之后将开启新对话！`
            },
          ]           
        }else{
          this.history=[
            {
                role: "system", 
                content: "You are a helpful assistant."
            },
            {
                role: "system",
                content: `fileid://${data.file_object.id}`,
            }
          ] 
        }
      }else{
        return this.$message({
            type: "warning",
            message: '上传的文件错误, 文件大小请勿超过128KB!',
          });
      }
    },
    uploadAttachment(){
      UploadFile(this.modelType,this.updateAttachment)
    },
    compileMarkdown(mdText) {
      marked.setOptions({
        renderer: new marked.Renderer(),
        gfm: true,
        tables: true,
        breaks: false,
        pedantic: false,
        sanitize: false,
        smartLists: true,
        smartypants: false,
      })      
      return marked.parse(mdText);
    },
    async previewAttachment(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})
      window.open(res.data)
    },
    async previewImage(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      this.$hevueImgPreview({url:res.data})
    },
    attachmentDelete(id,url) {
      this.$confirm("是否结束文件对话,结束后将开启新对话！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const type=this.modelType=='qwen-long'?'qwen':'kimi'
        await http.delete(`/openai/${type}/file/${id}`);
        await http.delete("/oss/upload/file",{data:{url}});
        this.file=null
        this.contentStyle.height='calc(100vh - 160px)'
        this.history=[{
          role:'assistant',
          content:`您好, 有什么问题我可以帮你解答吗？`
        }]
      });
    },
    scrollToBottom() {
      let content = this.$refs.scrollContainer;
      if(content.scrollHeight>content.clientHeight){
        content.scrollTop = content.scrollHeight;        
      }
    },
    handleOnComplete(){
      if(this.timer){
        clearInterval(this.timer)
      }   
    },
    handleOnBegin(){          
      this.timer=setInterval(()=>{
        this.scrollToBottom()
      },100)
    },
    onScroll(event) {
      // 如果滚动到底部, 则自动滚动
      const content = this.$refs.scrollContainer;
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        this.scrollToBottom();
      }
    },
    async newChat(){
      if(this.file){
        const type=this.modelType=='qwen-long'?'qwen':'kimi'
        await http.delete(`/openai/${type}/file/${this.file.file_object.id}`);
        await http.delete("/oss/upload/file",{data:{url:this.file.url}});
        this.file=null
        this.contentStyle.height='calc(100vh - 160px)'
      }
      this.history=[{
        role:'assistant',
        content:`您好, 有什么问题我可以帮你解答吗？` 
      }]
    },
    async fetchEnableStatus(){
      const res = await http.get('/setting/systemInfo/openai/enableStatus');
      this.options=res.data.map(item=>{
        const option= this.options.find(i=>i.modelType==item)
        option.isEnable=true
        return option
      }).filter(v=>v!=undefined)
    }
  },
  beforeDestroy(){
    if(this.timer){
      clearInterval(this.timer)
    }   
  },
  created(){
    this.fetchEnableStatus()
  }
};
</script>
<style scoped>
.openai>>>.el-input__count{
  right:105px;
  bottom: 8px;
  font-size:13px
}
.openai>>>p{
  margin:0 ;
}
.my-header{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  line-height:35px;
  border-bottom: 1px solid rgb(230, 230, 230);
}
.title{
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}
.title span{
  font-weight: 700;
  font-size: 16px;
  margin: 0 2px 0 5px;
  color: rgb(122, 122, 122);
}
.title div{
  width: 150px;
  height: 35px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-left:3px;
}
.el-image{
  width: 24px;
  height: 24px;
  vertical-align: middle;
  border-radius: 17px;
}
.icon-assistant{
  font-size: 24px;
  display: flex;
  flex-flow:row;
  align-items: center;
}
.question{
  position: relative;
}
.icon-attachment{
  font-size: 23px;
  position:absolute;
  right:55px;
  bottom:6px;
  cursor: pointer;
}
.icon-send{
  font-size: 24px;
  position:absolute;
  right:15px;
  bottom:6px;
  cursor: pointer;
}
.Delete-icon{
  font-size: 16px;
  position:absolute;
  top: 3px;
  right: 3px;
  cursor: pointer;
}
.attachment{
  position:relative;
  width:130px;
  border-radius: 3px;
  cursor: pointer;
  background:rgb(216, 216, 216); 
  margin-top:2px;
}
.file-title{
  display:flex;
  flex-flow:column nowrap;
  justify-content:center;
}
.file-title span{
  display: -webkit-box; /* 使用 Webkit 的盒子模型 */
  line-clamp: 2; /* 最多显示两行 */
  -webkit-line-clamp: 2; /* 最多显示两行 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 使用省略号表示多余的内容 */
  font-size:13px;
  margin:5px;
}
.image{
  height: 50px;
  width:50px;
  margin: 0 5px;
  cursor: pointer;
}
</style>
<style lang="scss">
.el-select-dropdown{
  z-index:30000!important;  
}
.typing p{
  min-height: 24px;
  align-content: center;
  margin: 0 auto;
}
pre{
  code{
    width: 500px;
    font-size: 13px;
    background-color: #30353f; /* 代码块背景色 */
    color: #abb2bf;
    font-family: Fira Code,Fira Mono,Menlo,Consolas,DejaVu Sans Mono,monospace;
    text-shadow: 0 1px rgba(0, 0, 0, .3);
    direction: ltr;
    text-align: left;
    white-space:pre;
    word-spacing: normal;
    word-break: normal;
    line-height: 1.5;
    tab-size: 2;
    hyphens: none;
    border-radius: 5px;
    padding: 12px;
    display:block;
    overflow-x: auto; /* 超出部分滚动 */
    position: relative;
  }  
}
.el-message-box__wrapper{
  z-index: 20005!important;
}
</style>
